import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'
import UserContext from '../../contexts/UserContext'
import { hasModulePermission } from '../../config/modulesByTenant'
import { useTenant } from '../../contexts/TenantContext'

interface PermissionGuardProps {
  children: React.ReactNode
  permission: string
  dependencies?: string[]
  redirectTo?: string
}

const PermissionGuard: React.FC<PermissionGuardProps> = ({ 
  children, 
  permission, 
  dependencies = [], 
  redirectTo = '/panel' 
}) => {
  const { user } = useContext(UserContext)
  const { tenantId } = useTenant()

  // Se tenant ainda não definido, aguardamos (banner instrui re-login quando aplicável)
  if (tenantId === null) {
    return <div>Carregando tenant...</div>
  }

  if (!user.permissions) {
    return <Navigate to={redirectTo} replace />
  }

  const moduleConfig = {
    name: '',
    path: '',
    image: '',
    section: '',
    permission,
    dependencies: dependencies.length > 0 ? dependencies : undefined
  }

  const hasPermission = hasModulePermission(moduleConfig, user.permissions)

  if (!hasPermission) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}

export default PermissionGuard
